export default __webpack_public_path__ + "static/media/Prancheta 2.b4f34ea7.svg";